export {AccountManagementModule} from "./core/account-management.module";
export {AccountManagementProviderService} from "./core/account-management-provider.service";
export {ServicesInstantiatorService as AccountManagementServicesInstantiatorService} from "./core/services/services-instantiator.service";